import { createConcurrentCustomMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { LEGACY_EXTENSION_LOADING_CUSTOM_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const LEGACY_EXTENSION_LOADING_METRIC = createConcurrentCustomMetric({
	key: LEGACY_EXTENSION_LOADING_CUSTOM_KEY,
});
